import React, { Component } from 'react';
import { observer } from 'mobx-react';

import Container from './Container';
import Chevron from './Chevron';
import Value from './Value';

@observer
export default class RangeInput extends Component {
  currentIndex = () =>
    this.props.range.reduce((currentIndex, value, index) => {
      if (value === this.props.value) {
        return index;
      }
      return currentIndex;
    }, null);

  getValue = value => (this.props.values ? this.props.values(value) : value);

  nextIncrement = () => this.currentIndex() + (this.props.step || 1);
  increment = () => {
    const nextValue = this.nextIncrement();
    if (nextValue < this.props.range.length) {
      this.props.onChange(this.props.range[nextValue]);
    } else if (this.props.wrapAround) {
      // value off end, wrap around to beginning
      this.props.onChange(this.props.range[0]);
    }
  };

  nextDecrement = () => this.currentIndex() - (this.props.step || 1);
  decrement = () => {
    const nextValue = this.nextDecrement();
    if (nextValue >= 0) {
      this.props.onChange(this.props.range[nextValue]);
    } else if (this.props.wrapAround) {
      // value before start, wrap around to end
      this.props.onChange(this.props.range[this.lastValidIndex()]);
    }
  };

  lastValidIndex = () => {
    let lastValidIndex;
    for (lastValidIndex = this.props.range.length - 1; lastValidIndex; lastValidIndex--) {
      if (!(lastValidIndex % this.props.step)) {
        break;
      }
    }
    return lastValidIndex;
  };

  render() {
    return (
      <Container className={this.props.className}>
        <Chevron
          direction="up"
          onClick={this.increment}
          disabled={!this.props.wrapAround && this.nextIncrement() >= this.props.range.length}
        />
        <Value>{this.getValue(this.props.value)}</Value>
        <Chevron
          direction="down"
          onClick={this.decrement}
          disabled={!this.props.wrapAround && this.nextDecrement() < 0}
        />
      </Container>
    );
  }
}
